module.exports = __webpack_public_path__ + "img/experience-bar-mask.98766a81.png";